<template>
  <select v-model="value" :disabled="disabled" :data-test="value">
    <option v-for="(option, index) in options" :key="index"
      :value="typeof option === 'object' ? option.value : option"
      :selected="typeof option === 'object' ? option.selected : null"
      :disabled="typeof option === 'object' ? option.disabled : null"
    >
      {{ typeof option === 'object' ? option.text : option }}
    </option>
  </select>
</template>

<script setup>
import {defineProps, computed} from 'vue';

const value = computed({
  get: () => props.modelValue,
  set: (val) => emit('update:modelValue', val)
})
const emit = defineEmits(['update:modelValue'])

const props = defineProps({
  modelValue: {
    type: String,
    default: ''
  },
  options: Array,
  disabled: Boolean
})

</script>